import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReceiptScanner from './ReceiptScanner';

interface NavigationProps {
  onLogout: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onLogout }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showScanModal, setShowScanModal] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    setIsMenuOpen(false);
    onLogout();
  };

  return (
    <>
      {/* Header mit Burger-Icon */}
      <nav style={{
        background: 'white',
        padding: '15px 20px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 999
      }}>
        {/* Logo */}
        <div style={{
          display: 'inline-block',
          background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
          color: 'white',
          padding: '8px 16px',
          borderRadius: '12px',
          fontWeight: 'bold',
          fontSize: '14px',
          boxShadow: '0 4px 12px rgba(15, 32, 39, 0.4)',
          transform: 'rotate(-1deg)',
          transition: 'all 0.3s ease',
          cursor: 'pointer'
        }}
        onClick={() => navigate('/dashboard')}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'rotate(0deg) scale(1.05)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(15, 32, 39, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'rotate(-1deg)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(15, 32, 39, 0.4)';
        }}>
          💰 MeineGroschen
        </div>

        {/* User Info Desktop */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ color: '#666', fontSize: '14px', display: window.innerWidth <= 768 ? 'none' : 'block' }}>
            {user.firstName} {user.lastName}
          </span>
          
          {/* Scan Button - nur Mobile */}
          {window.innerWidth <= 768 && (
            <button
              onClick={() => setShowScanModal(true)}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: '12px',
                color: 'white',
                width: '42px',
                height: '42px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                transition: 'all 0.3s ease'
              }}
              aria-label="Beleg scannen"
            >
              🧾
            </button>
          )}
          
          {/* Burger Icon */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              display: 'flex',
              flexDirection: 'column',
              gap: '5px',
              transition: 'all 0.3s ease'
            }}
            aria-label="Menü"
          >
            <div style={{
              width: '25px',
              height: '3px',
              background: '#2c5364',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              transform: isMenuOpen ? 'rotate(45deg) translateY(8px)' : 'none'
            }} />
            <div style={{
              width: '25px',
              height: '3px',
              background: '#2c5364',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              opacity: isMenuOpen ? 0 : 1
            }} />
            <div style={{
              width: '25px',
              height: '3px',
              background: '#2c5364',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              transform: isMenuOpen ? 'rotate(-45deg) translateY(-8px)' : 'none'
            }} />
          </button>
        </div>
      </nav>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          onClick={() => setIsMenuOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            animation: 'fadeIn 0.3s ease'
          }}
        />
      )}

      {/* Sidebar Menu */}
      <div style={{
        position: 'fixed',
        top: 0,
        right: isMenuOpen ? 0 : '-300px',
        width: '300px',
        height: '100vh',
        background: 'linear-gradient(180deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
        boxShadow: isMenuOpen ? '-4px 0 20px rgba(0, 0, 0, 0.3)' : 'none',
        transition: 'right 0.3s ease',
        zIndex: 1001,
        overflowY: 'auto',
        padding: '20px'
      }}>
        {/* Close Button */}
        <button
          onClick={() => setIsMenuOpen(false)}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            color: 'white',
            fontSize: '24px',
            width: '35px',
            height: '35px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
        >
          ×
        </button>

        {/* User Info */}
        <div style={{
          color: 'white',
          padding: '20px 0 30px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          marginBottom: '20px'
        }}>
          <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '5px' }}>
            {user.firstName} {user.lastName}
          </div>
          <div style={{ fontSize: '13px', opacity: 0.8 }}>
            {user.email}
          </div>
        </div>

        {/* Menu Items */}
        <nav>
          <MenuItem label="Dashboard" onClick={() => handleNavigation('/dashboard')} />
          <MenuItem label="Konten" onClick={() => handleNavigation('/accounts')} />
          <MenuItem label="Schulden" onClick={() => handleNavigation('/debts')} />
          <MenuItem label="Abonnements" onClick={() => handleNavigation('/subscriptions')} />
          <MenuItem label="Transfers" onClick={() => handleNavigation('/transfers')} />
          <MenuItem label="Transaktionen" onClick={() => handleNavigation('/transactions')} />
          
          <div style={{ height: '20px' }} />
          
          <MenuItem label="Einstellungen" onClick={() => handleNavigation('/settings')} />
          {user.isAdmin && (
            <MenuItem label="Admin" onClick={() => handleNavigation('/admin')} />
          )}
          
          <div style={{ 
            borderTop: '1px solid rgba(255, 255, 255, 0.2)', 
            margin: '20px 0',
            paddingTop: '20px' 
          }}>
            <MenuItem label="Impressum" onClick={() => handleNavigation('/imprint')} small />
            <MenuItem label="Datenschutz" onClick={() => handleNavigation('/privacy')} small />
          </div>
          
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '12px 16px',
              background: 'rgba(255, 107, 107, 0.2)',
              border: '2px solid rgba(255, 107, 107, 0.5)',
              borderRadius: '12px',
              color: 'white',
              fontSize: '15px',
              fontWeight: 'bold',
              cursor: 'pointer',
              marginTop: '10px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 107, 107, 0.3)';
              e.currentTarget.style.transform = 'translateX(-5px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 107, 107, 0.2)';
              e.currentTarget.style.transform = 'translateX(0)';
            }}
          >
            Abmelden
          </button>
        </nav>
      </div>

      {/* Receipt Scanner Modal */}
      {showScanModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            width: '100%',
            maxWidth: '500px',
            maxHeight: '90vh',
            overflow: 'auto',
            position: 'relative'
          }}>
            <button
              onClick={() => setShowScanModal(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'rgba(0, 0, 0, 0.5)',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                cursor: 'pointer',
                zIndex: 10
              }}
            >
              ×
            </button>
            <ReceiptScanner onClose={() => setShowScanModal(false)} />
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </>
  );
};

// Menu Item Component
const MenuItem: React.FC<{ label: string; onClick: () => void; small?: boolean }> = ({ 
  label, 
  onClick, 
  small = false 
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        width: '100%',
        padding: small ? '10px 16px' : '14px 16px',
        background: 'rgba(255, 255, 255, 0.1)',
        border: 'none',
        borderRadius: '12px',
        color: 'white',
        fontSize: small ? '14px' : '15px',
        fontWeight: small ? 'normal' : '500',
        cursor: 'pointer',
        marginBottom: '8px',
        transition: 'all 0.3s ease',
        textAlign: 'left',
        opacity: small ? 0.7 : 1
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
        e.currentTarget.style.transform = 'translateX(-5px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
        e.currentTarget.style.transform = 'translateX(0)';
      }}
    >
      {label}
    </button>
  );
};

export default Navigation;
